import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import TickerSearch from './TickerSearch'; // Add this import

const SearchPage = () => {
    const { user, isAuthenticated, loading, validateCurrentUser, logout } = useAuth();
    const navigate = useNavigate();
    const [dashboardLoading, setDashboardLoading] = useState(true);

    useEffect(() => {
        const validateAccess = async () => {
            if (!isAuthenticated) {
                navigate('/login');
                return;
            }

            try {
                setDashboardLoading(true);
                const result = await validateCurrentUser();
                if (!result.success) {
                    navigate('/login');
                    return;
                }
            } catch (error) {
                navigate('/login');
            } finally {
                setDashboardLoading(false);
            }
        };

        // validateAccess();
        setDashboardLoading(false);
    }, [isAuthenticated, navigate, validateCurrentUser]);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    if (loading || dashboardLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
                    <p className="mt-4 text-gray-600">Validating your session...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        navigate('/login');
        return null;
    }

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            {/* <header className="bg-white shadow">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center py-6">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
                            <p className="text-gray-600">Welcome back, {user.full_name || user.email}!</p>
                        </div>
                        <div className="flex items-center space-x-4">
                            <span className="text-sm text-gray-500">
                                {user.email}
                            </span>
                            <button
                                onClick={handleLogout}
                                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm font-medium"
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </header> */}

            {/* Main Content */}
            <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 py-6 sm:px-0">
                    {/* Ticker Search Section */}
                    <div className="mb-8">
                        <TickerSearch />
                    </div>
                    
                    {/* Rest of your dashboard content */}
                    <div className="border-4 border-dashed border-gray-200 rounded-lg h-96 p-8">
                        <div className="text-center">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                Welcome to Your Smart Portfolio Dashboard!
                            </h2>
                            <p className="text-gray-600 mb-8">
                                Use the search above to analyze any stock ticker.
                            </p>
                            
                            {/* User Info Card */}
                            <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-6">
                                <h3 className="text-lg font-semibold mb-4">Your Profile</h3>
                                <div className="space-y-2 text-left">
                                    <div>
                                        <span className="font-medium">Email:</span> {user.email}
                                    </div>
                                    <div>
                                        <span className="font-medium">Full Name:</span> {user.full_name || 'Not provided'}
                                    </div>
                                    <div>
                                        <span className="font-medium">Status:</span> 
                                        <span className={`ml-2 px-2 py-1 text-xs rounded-full ${user.is_verified ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                            {user.is_verified ? 'Verified' : 'Pending Verification'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default SearchPage;